import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import menuFormationsMenuStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'menuFormationsMenu'
const customImplement: CustomStoreImplementationOptions = menuFormationsMenuStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function menuFormationsMenuFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('menu-formations.title', 'Menu Formations'),
        $description: $translate('menu-formations.description', ''),
        $publishedTime: new Date('2023-04-13T13:31:18.783Z'),
        $modifiedTime: new Date('2023-06-06T09:14:49.541Z'),
        // Constants,
        $constants: {},
        // Data,
        $info: { menuFormations: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async nosFormationsClick () {
        await navigateTo({ name: 'Formations' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async pedagogieMatchersClick () {
        await navigateTo({ name: 'Pedagogie' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async tarifsFinancementsClick () {
        await navigateTo({ name: 'Financement' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return menuFormationsMenuFactory(storeId)()
}

export const menuFormationsMenuRaw = menuFormationsMenuFactory()
export const menuFormationsMenu = () => menuFormationsMenuRaw() as MergeCustomStore<typeof menuFormationsMenuStoreCustom.instance>
